import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import {
  FunctionAuditConfig,
  ProjectConfig,
} from '../../common/models/common.config';
import { Logger, LoggerLevelEnum } from '../../common/public-api';
import { LocalStorageService } from '../../common/services/local-storage.service';
import { UserProfileService } from '../../core/services';
import { SessionStorageService } from '../../core/services/session-storage.service';
import { UserProfile } from '../../models/common/user-profile.model';
import { AuditInfo } from '../../models/rt-common/audit-info';
import { LocalStorageEnum } from '../enums';
import { SessionStorageEnum } from '../enums/session-storage.enum';
import { AuditInfoEnum } from '../enums';
import { getDeptId } from '../utils/user-profile-utils';

@Injectable({
  providedIn: 'root',
})
export class AuditInfoService {
  constructor(
    private _localStorageService: LocalStorageService,
    private _sessionStorageService: SessionStorageService,
    private _logger: Logger,
    private userProfileService: UserProfileService
  ) {}
  /**
   * AuditInfo 初始化
   * @description 用於App Init使用
   * @param projectConfig
   * @param functionAuditConfig
   */
  public setAuditInfoService(
    projectConfig: ProjectConfig,
    functionAuditConfig?: FunctionAuditConfig
  ) {
    const useAuditUseInfo = {} as AuditInfo;
    const useUserProfile = this._localStorageService.getItem(
      LocalStorageEnum.USER_INFO_STORAGE_KEY
    ) as UserProfile;

    useAuditUseInfo.time = new Date().toISOString();
    useAuditUseInfo.systemCode = projectConfig.systemCode;
    useAuditUseInfo.systemGroupCode = projectConfig.systemGroupCode;
    if (useUserProfile) {
      useAuditUseInfo.userNo = useUserProfile.userNo;
    }
    // 當前使用者所屬部門
    useAuditUseInfo.deptId = getDeptId(this.userProfileService);

    if (functionAuditConfig) {
      useAuditUseInfo.caseNo = functionAuditConfig.caseNo;
      useAuditUseInfo.funcCode = functionAuditConfig.funcCode;
      useAuditUseInfo.mode = functionAuditConfig.mode;
    }
    // useAuditUseInfo.
    this._sessionStorageService.setItem(
      SessionStorageEnum.AUDIT_INFO_KEY,
      useAuditUseInfo
    );
  }
  /**
   * 更新auditInfo
   * @description 用於案件ngInit使用，如是傳入整個設定物件會覆蓋FunctionAuditConfig，如傳入string會僅更新caseNo
   * @param setting
   */
  public updateAuditInfo(setting: FunctionAuditConfig | string) {
    const useAuditUseInfo = this._sessionStorageService.getItem(
      SessionStorageEnum.AUDIT_INFO_KEY
    ) as AuditInfo;
    useAuditUseInfo.time = new Date().toISOString();
    if (_.isObject(setting)) {
      useAuditUseInfo.funcCode = setting.funcCode;
      useAuditUseInfo.mode = setting.mode;
      useAuditUseInfo.caseNo = setting.caseNo;
    } else {
      useAuditUseInfo.caseNo = setting;
    }
    // useAuditUseInfo.
    this._sessionStorageService.setItem(
      SessionStorageEnum.AUDIT_INFO_KEY,
      useAuditUseInfo
    );
    this._logger.log(LoggerLevelEnum.Info, 'updateAuditInfo', setting);
  }
  /**
   * 更新auditInfo
   * @description 依據key更新auditInfo
   * @param setting
   */
  public updateAuditInfoByKey(key: string, setting: any) {
    const useAuditUseInfo = this._sessionStorageService.getItem(
      SessionStorageEnum.AUDIT_INFO_KEY
    ) as AuditInfo;
    useAuditUseInfo.time = new Date().toISOString();
    try {
      useAuditUseInfo[key as keyof AuditInfo] = setting as never;
      if (key === AuditInfoEnum.DEPT_ID_KEY)
      {
        if (setting === null || setting === undefined)
        {
          useAuditUseInfo.deptId = 0;
        }
      }
      // useAuditUseInfo.
      this._sessionStorageService.setItem(
        SessionStorageEnum.AUDIT_INFO_KEY,
        useAuditUseInfo
      );
    } catch (error) {
      console.log('wrong key', key);
    }
    this._logger.log(LoggerLevelEnum.Info, 'updateAuditInfoByKey', setting);
  }
  /**
   * 更新auditInfo的使用者資訊
   * @description 用於app載入或是userProfile更新時使用
   * @param setting
   */
  public updateAuditUserInfo() {
    const useAuditUseInfo = this._sessionStorageService.getItem(
      SessionStorageEnum.AUDIT_INFO_KEY
    ) as AuditInfo;
    const useUserProfile = this._localStorageService.getItem(
      LocalStorageEnum.USER_INFO_STORAGE_KEY
    ) as UserProfile;
    if (useUserProfile) {
      useAuditUseInfo.userNo = useUserProfile.userNo;
      useAuditUseInfo.deptId = getDeptId(this.userProfileService);
    }

    this._sessionStorageService.setItem(
      SessionStorageEnum.AUDIT_INFO_KEY,
      useAuditUseInfo
    );
  }
}
